export const legacyRadii = {
  full: '9999px',
};
